// super thin wrapper around localStorage
export class WebStorageCache {
    async init() {
        return;
    }
    async setItem(key, value) {
        localStorage.setItem(key, value);
    }
    async getItem(key) {
        return localStorage.getItem(key);
    }
    async getItems(keys) {
        const results = new Map();
        for (const key of keys) {
            results.set(key, localStorage.getItem(key));
        }
        return results;
    }
    async setItems(entries) {
        for (const [key, value] of entries) {
            localStorage.setItem(key, value);
        }
    }
    async removeItem(key) {
        localStorage.removeItem(key);
    }
    async clear() {
        localStorage.clear();
    }
}
//# sourceMappingURL=WebStorageCache.js.map